import React, { useState } from 'react'

import {
    Avatar,
    Box,
    Flex,
    Grid,
    HStack,
    Image,
    Link,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    VStack,
} from '@chakra-ui/react'

import decodeHtmlEntitiesRecursive from '@core/utils/helpers/decodeHtmlEntitiesRecursive'
import useApplyV2NavTranslations from '@core/utils/hooks/useApplyV2NavTranslations'

import contactLinkedin from '@page/post/assets/images/contact_linkedin.svg'
import PersonContactLink from '@page/post/components/AsideInfo/PersonContactLink'
import PostPageV2ContactPersonModal from '@page/post-v2/components/PostPageV2ContactPersons/PostPageV2ContactPersonModal'
import type { ContactV2, PostInfoV2 } from '@page/post-v2/types'
import './PostPageV2ContactPersons.scss'

const baseClass = 'PostPageV2ContactPersons'

interface PostPageV2ContactPersonsProps {
    postInfo?: PostInfoV2 | undefined | null
    isLoading?: boolean
}

function PostPageV2ContactPersons({ postInfo, isLoading }: PostPageV2ContactPersonsProps) {
    const { getTitle } = useApplyV2NavTranslations()
    const [contactPerson, setContactPerson] = useState<ContactV2 | null>(null)

    const contactPersons = postInfo?.data?.contacts ?? []

    function formatURL(url: string) {
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return `https://${url}`
        }
        return url
    }

    // const copyToClipBoard = async (copyMe: string) => {
    //     try {
    //         setShowCopyLabel(true)
    //         await navigator.clipboard.writeText(copyMe)
    //
    //         setTimeout(() => {
    //             setShowCopyLabel(false)
    //         }, 2000)
    //     } catch (err) {}
    // }

    if (isLoading || !contactPersons || contactPersons.length === 0) {
        return null
    }

    return (
        <div className={baseClass}>
            <div className={`${baseClass}__title`}>{getTitle('217', 'Contact persons')}</div>
            <div className={`${baseClass}__list`}>
                {contactPersons.map((contact) => (
                    <Box key={`${contact.lastName}-${contact.lastName}`}>
                        <HStack alignItems={'start'} gap={6}>
                            <Avatar
                                name={contact.lastName}
                                src={contact.image}
                                w={'80px'}
                                h={'80px'}
                                // filter={isPostExpired ? 'saturate(0) opacity(0.7)' : ''}
                            />
                            <Flex flexDirection={'column'} alignItems={'start'}>
                                <Text
                                    wordBreak={'break-word'}
                                    fontSize={'sm'}
                                    fontWeight={'semibold'}
                                    color={'text.main'}
                                    // opacity={isPostExpired ? 0.4 : 1}
                                >
                                    {decodeHtmlEntitiesRecursive(contact.firstName)}{' '}
                                    {decodeHtmlEntitiesRecursive(contact.lastName)}
                                </Text>
                                <Text
                                    mt={1}
                                    wordBreak={'break-word'}
                                    fontSize={'sm'}
                                    color={'text.secondary'}
                                    // opacity={isPostExpired ? 0.4 : 1}
                                >
                                    {decodeHtmlEntitiesRecursive(contact.title)}
                                </Text>
                                <Link
                                    onClick={() => {
                                        setContactPerson(contact)
                                    }}
                                    mt={'4px'}
                                    lineHeight={'20px'}
                                    fontSize={'12px'}
                                    color={'#2F80ED'}
                                    fontWeight={600}
                                    borderRadius={'6px'}
                                    transition={'backgroundColor 0.2s ease-in'}
                                    _hover={{ textDecoration: 'none', backgroundColor: 'rgba(47, 128, 237, 0.05)' }}
                                >
                                    {getTitle('8753', 'See contact details')}
                                </Link>
                                <PostPageV2ContactPersonModal
                                    contactPerson={contactPerson}
                                    onClose={() => setContactPerson(null)}
                                />
                                {/*{contactPerson && (*/}
                                {/*    <Modal*/}
                                {/*        isOpen={!!contactPerson}*/}
                                {/*        onClose={() => setContactPerson(null)}*/}
                                {/*        size={'md'}*/}
                                {/*        // zIndex={9991}*/}
                                {/*    >*/}
                                {/*        <ModalOverlay backgroundColor={'rgba(0,0,0,0.2)'} />*/}
                                {/*        <ModalContent*/}
                                {/*            className={'ContactPerson__content'}*/}
                                {/*            maxWidth={'432px'}*/}
                                {/*            // zIndex={9992}*/}
                                {/*            margin={'auto'}*/}
                                {/*        >*/}
                                {/*            <ModalHeader*/}
                                {/*                pt={'48px'}*/}
                                {/*                px={'48px'}*/}
                                {/*                pb={'32px'}*/}
                                {/*                fontSize={'24px'}*/}
                                {/*                color={'#1A1A1A'}*/}
                                {/*            >*/}
                                {/*                {getTitle('8755')}*/}
                                {/*            </ModalHeader>*/}
                                {/*            <ModalCloseButton top={'50px'} right={'22px'} />*/}
                                {/*            <ModalBody px={0}>*/}
                                {/*                <Grid*/}
                                {/*                    templateColumns={'auto minmax(100px, 1fr)'}*/}
                                {/*                    overflow={'hidden'}*/}
                                {/*                    rowGap={'24px'}*/}
                                {/*                    columnGap={'16px'}*/}
                                {/*                    alignItems={'start'}*/}
                                {/*                    px={'48px'}*/}
                                {/*                >*/}
                                {/*                    <Avatar w={'80px'} h={'80px'} src={contactPerson?.image} />*/}
                                {/*                    <VStack alignItems={'start'} gap={0}>*/}
                                {/*                        <Text fontSize={'sm'} fontWeight={'semibold'} color={'#1A1A1A'}>*/}
                                {/*                            {decodeHtmlEntitiesRecursive(contact.firstName)}{' '}*/}
                                {/*                            {decodeHtmlEntitiesRecursive(contact.lastName)}*/}
                                {/*                        </Text>*/}
                                {/*                        {contactPerson?.title && (*/}
                                {/*                            <Text*/}
                                {/*                                fontSize={'sm'}*/}
                                {/*                                color={'text.secondary'}*/}
                                {/*                                lineHeight={'20px'}*/}
                                {/*                            >*/}
                                {/*                                {decodeHtmlEntitiesRecursive(contactPerson?.title)}*/}
                                {/*                            </Text>*/}
                                {/*                        )}*/}
                                {/*                        <Flex>*/}
                                {/*                            {contactPerson?.linkedin && (*/}
                                {/*                                <Link*/}
                                {/*                                    href={formatURL(contactPerson?.linkedin)}*/}
                                {/*                                    target={'_blank'}*/}
                                {/*                                    aria-label={'LinkedIn'}*/}
                                {/*                                    // opacity={isPostExpired ? 0.4 : 1}*/}
                                {/*                                    _hover={{*/}
                                {/*                                        transform: 'scale(1.2)',*/}
                                {/*                                    }}*/}
                                {/*                                >*/}
                                {/*                                    <HStack gap={2} mt={'8px'}>*/}
                                {/*                                        <Image*/}
                                {/*                                            src={contactLinkedin}*/}
                                {/*                                            w={'20px'}*/}
                                {/*                                            alt={'LinkedIn'}*/}
                                {/*                                            // filter={*/}
                                {/*                                            //     isPostExpired*/}
                                {/*                                            //         ? 'saturate(0) opacity(0.7)'*/}
                                {/*                                            //         : 'none'*/}
                                {/*                                            // }*/}
                                {/*                                        />*/}
                                {/*                                    </HStack>*/}
                                {/*                                </Link>*/}
                                {/*                            )}*/}
                                {/*                        </Flex>*/}
                                {/*                    </VStack>*/}
                                {/*                    <VStack alignItems={'start'} gap={'8px'} rowGap={'8px'}>*/}
                                {/*                        {contactPerson?.workPhone && (*/}
                                {/*                            <Text display={'flex'} gap={'8px'} fontSize={'sm'}>*/}
                                {/*                                <i className="fa-solid fa-phone ContactPerson__modal__icon" />*/}
                                {/*                                {getTitle('2415')}:*/}
                                {/*                            </Text>*/}
                                {/*                        )}*/}
                                {/*                        {contactPerson?.mobilePhone && (*/}
                                {/*                            <Text display={'flex'} gap={'8px'} fontSize={'sm'}>*/}
                                {/*                                <i className="fa-solid fa-mobile ContactPerson__modal__icon" />*/}
                                {/*                                {getTitle('2972')}:*/}
                                {/*                            </Text>*/}
                                {/*                        )}*/}
                                {/*                        {contactPerson?.email && (*/}
                                {/*                            <Text display={'flex'} gap={'8px'} fontSize={'sm'}>*/}
                                {/*                                <i className="fa-solid fa-envelope ContactPerson__modal__icon" />*/}
                                {/*                                {getTitle('92')}:*/}
                                {/*                            </Text>*/}
                                {/*                        )}*/}
                                {/*                    </VStack>*/}
                                {/*                    <VStack alignItems={'start'} gap={'8px'}>*/}
                                {/*                        {contactPerson?.workPhone && (*/}
                                {/*                            <PersonContactLink*/}
                                {/*                                type={'tel'}*/}
                                {/*                                value={contactPerson.workPhone.number}*/}
                                {/*                                phonePrefix={contactPerson.workPhone.prefix}*/}
                                {/*                            />*/}
                                {/*                        )}*/}
                                {/*                        {contactPerson?.mobilePhone && (*/}
                                {/*                            <PersonContactLink*/}
                                {/*                                type={'tel'}*/}
                                {/*                                value={contactPerson.mobilePhone.number}*/}
                                {/*                                phonePrefix={contactPerson.mobilePhone.prefix}*/}
                                {/*                            />*/}
                                {/*                        )}*/}
                                {/*                        {contactPerson?.email && (*/}
                                {/*                            <PersonContactLink*/}
                                {/*                                type={'mailto'}*/}
                                {/*                                value={contactPerson.email}*/}
                                {/*                            />*/}
                                {/*                        )}*/}
                                {/*                    </VStack>*/}
                                {/*                </Grid>*/}
                                {/*            </ModalBody>*/}
                                {/*            <ModalFooter pb={'48px'} px={'48px'} pt={'32px'}>*/}
                                {/*                /!*<Button*!/*/}
                                {/*                /!*    colorScheme="blue"*!/*/}
                                {/*                /!*    variant="outline"*!/*/}
                                {/*                /!*    width={'full'}*!/*/}
                                {/*                /!*    onClick={() => setContactPerson(null)}*!/*/}
                                {/*                /!*    _hover={{ bg: 'blue.500', color: 'white' }}*!/*/}
                                {/*                /!*>*!/*/}
                                {/*                /!*    {t('3723')}*!/*/}
                                {/*                /!*</Button>*!/*/}
                                {/*            </ModalFooter>*/}
                                {/*        </ModalContent>*/}
                                {/*    </Modal>*/}
                                {/*)}*/}
                            </Flex>
                        </HStack>
                    </Box>
                ))}
            </div>
        </div>
    )
}

export default PostPageV2ContactPersons
